export interface IEntity {

    id: string;
    createdBy: string;
    createdAt: Date;
    updatedBy: string;
    updatedAt: Date;
    active: boolean;

    [key: string]: any;
}